module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_vm._m(0), (_vm.isSupport) ? _c('div', {
    staticClass: "app-container"
  }, [_c('game')], 1) : _c('div', {
    staticClass: "not-support"
  }, [_vm._v("暂不支持此浏览器，请用谷歌浏览器打开此链接"), _c('a', {
    attrs: {
      "href": "http://www.google.cn/chrome/browser/desktop/index.html",
      "target": "_blank"
    }
  }, [_vm._v("谷歌浏览器下载地址")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://github.com/k55k32/quaver",
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "position": "absolute",
      "top": "0",
      "right": "0",
      "border": "0"
    },
    attrs: {
      "src": "https://camo.githubusercontent.com/38ef81f8aca64bb9a64448d0d70f1308ef5341ab/68747470733a2f2f73332e616d617a6f6e6177732e636f6d2f6769746875622f726962626f6e732f666f726b6d655f72696768745f6461726b626c75655f3132313632312e706e67",
      "alt": "Fork me on GitHub",
      "data-canonical-src": "https://s3.amazonaws.com/github/ribbons/forkme_right_darkblue_121621.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ced7c9b"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 85
// module chunks = 1